import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { DownloadBillingForm } from '@/components/forms/DownloadBillingForm'

export default function DownloadBillingPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ shippingLineId: string; billingStatementId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const billingStatementId = params.billingStatementId ? parseInt(params.billingStatementId, 10) : undefined

  // Get data from navigation state or route params
  const navigationState = location.state as
    | {
        shippingLineName?: string
        shippingLineId?: string
        billingStatementId?: number
      }
    | null

  const finalShippingLineId =
    navigationState?.shippingLineId || paramsShippingLineId
  const finalBillingStatementId = navigationState?.billingStatementId || billingStatementId

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Download Billing Statement
            </Heading>
          </CardHeader>
          <CardBody>
            <DownloadBillingForm
              billingStatementId={finalBillingStatementId}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

